import React, { Component } from 'react';
import Analytics from 'react-ga';
import ContentSection from '../ContentSection';
import Navbar from '../Navbar';
import CubeGrid from '../CubeGrid';
import './styles.css';

export default class HomePage extends Component {

  componentDidMount() {

    Analytics.pageview('/');
  }

  render() {
    return (
      <Navbar location={this.props.location}>
        <div className="homepage">
          <ContentSection>
            <CubeGrid/>
          </ContentSection>
        </div>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/index.js